export default __webpack_public_path__ + "static/media/drinkslogoIcon.e7abd17a.svg";